module.exports = __webpack_public_path__ + "img/employee_all.eb2ba985.svg";